import axios from "axios";

const URL_AUTH = import.meta.env.VITE_AUTH_URL;

export const ApproveSensitiveChangeService = (token, changeId, comment) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axios.put(
        `${URL_AUTH}/api/admin/v1/sensitive/${changeId}/approve`,
        comment,
        {
          headers: {
            "X-localization": `${window.localStorage.getItem("i18nextLng")}`,
            Authorization: `Bearer ${token}`,
          }
        }
      );
      console.log(response);
      resolve(response);
    } catch (error) {
      console.log("error:", error);
      reject(error);
    }
  });
};